import "./index.scss"

export const PrivacyPolicy: React.FC = () => {
    return (
        <div className="privacy-policy">
            <header className="header">
                <div className="container">
                    <h1>Privacy Policy</h1>
                    <p className="last-updated">Last Updated: January 22, 2025</p>
                </div>
            </header>

            <main className="container">
                <div className="content">
                    <p className="intro">
                        At Moodra App ("we," "us," or "our"), we are committed to protecting your privacy. This Privacy Policy
                        explains how we collect, use, and share your personal information when you access our website, join our
                        waiting list, and participate in assessments. By using our website and providing your information, you agree
                        to the terms outlined in this policy.
                    </p>

                    <section>
                        <h2>1. Information We Collect</h2>
                        <p>We collect the following types of information when you interact with our website:</p>

                        <h3>1.1 Personal Information:</h3>
                        <p>
                            Name, email address, country, and information about the challenges you are facing when you join our
                            waiting list.
                        </p>

                        <h3>1.2 Survey Information:</h3>
                        <p>
                            After joining the waiting list, we send you a survey to complete. This may include additional personal
                            details such as your birth date, responses to questions, and other relevant data to help us understand
                            your needs.
                        </p>
                    </section>

                    <section>
                        <h2>2. Personal Data of Children</h2>
                        <p>
                            <strong>Children:</strong> Moodra is not intended for children under the age of 16, and we do not knowingly
                            collect personal information from children. If we become aware that we have collected personal information
                            from a child under 16, we will take steps to delete such information as soon as possible. Moodra is not
                            liable for any issues related to children using our services. If you believe that a child under 16 may
                            have provided us personal data, please contact us at hi@moodra-app.com
                        </p>
                    </section>

                    <section>
                        <h2>3. How We Use Your Information</h2>
                        <p>We use the personal information we collect for the following purposes:</p>
                        <ul>
                            <li>To add you to our waiting list and communicate with you about the upcoming app launch.</li>
                            <li>
                                To send you a survey and assessment information to understand your needs and provide personalized
                                insights.
                            </li>
                            <li>To improve our website, services, and the app features based on your responses.</li>
                            <li>
                                To send periodic updates about our app, product developments, and other relevant information related to
                                our services.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>4. How We Share Your Information</h2>
                        <p>
                            We do not sell, rent, or share your personal information with third parties for marketing purposes.
                            However, we may share your data with trusted third-party service providers who assist us with services
                            such as email services or survey tools. These third parties are obligated to protect your data and can
                            only use it for specified purposes.
                        </p>
                    </section>

                    <section>
                        <h2>5. Data Security</h2>
                        <p>
                            We take data security seriously and implement reasonable technical and organizational measures to protect
                            your personal information from unauthorized access, alteration, or disclosure. However, please note that
                            no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee
                            absolute security.
                        </p>
                    </section>

                    <section>
                        <h2>6. Your Data Protection Rights</h2>
                        <p>Depending on where you reside, you may have the following rights regarding your personal data:</p>

                        <h3>6.1 Access:</h3>
                        <p>You can request access to the personal information we hold about you.</p>

                        <h3>6.2 Correction:</h3>
                        <p>You can request corrections to any inaccurate or incomplete data.</p>

                        <h3>6.3 Deletion:</h3>
                        <p>You can request the deletion of your personal information.</p>

                        <h3>6.4 Withdrawal of Consent:</h3>
                        <p>
                            You can withdraw your consent at any time by contacting us, and we will stop processing your data unless
                            we have another legal basis to do so. To exercise any of these rights, please contact us at
                            hi@moodra-app.com
                        </p>
                    </section>

                    <section>
                        <h2>7. Links to Other Websites</h2>
                        <p>
                            Our website may contain links to third-party websites. We are not responsible for the privacy practices or
                            content of these sites. Please review the privacy policies of any third-party websites you visit.
                        </p>
                    </section>

                    <section>
                        <h2>8. Updates to This Privacy Policy</h2>
                        <p>
                            We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements.
                            When we update this policy, we will post the new version on this page and update the "Effective Date" at
                            the top of the policy. We encourage you to review this policy regularly.
                        </p>
                    </section>

                    <section>
                        <h2>9. Contact Us</h2>
                        <p>
                            If you have any questions about this Privacy Policy or our data practices, please contact us at
                            hi@moodra-app.com.
                        </p>
                    </section>
                </div>
            </main>
        </div>
    )
}